import React, {useEffect} from "react";
import PropTypes from "prop-types";
import ReactAudioPlayer from "react-h5-audio-player";
import {ReactComponent as Forward30Icon} from "../../../assets/audioPlayer/Forward.svg";
import {ReactComponent as Backward30Icon} from "../../../assets/audioPlayer/Rewind.svg";
import {ReactComponent as PlayIcon} from "../../../assets/audioPlayer/Play.svg";
import {ReactComponent as PauseIcon} from "../../../assets/audioPlayer/Pause.svg";
import "react-h5-audio-player/lib/styles.css";
import "./audioPlayer.scss";

const AudioPlayer = (props) => {
    const {
        src,
        audioRef,
        onPlay,
        onPause,
        onSeeked,
        onLoadedData,
        onListen,
        onError
    } = props;
    return <div className={"audio-player"}>
        <ReactAudioPlayer
            layout="horizontal-reverse"
            src={src}
            ref={audioRef}
            onError={onError}
            onPlay={onPlay}
            onPause={onPause}
            onSeeked={onSeeked}
            onLoadedData={onLoadedData}
            onListen={onListen}
            listenInterval={800}
            style={{ width: "85%" }}
            customAdditionalControls={[]}
            showDownloadProgress={false}
            showJumpControls={true}

            progressJumpSteps={{
                forward: 10000,
                backward: 10000,
            }}
            customIcons={{
                forward: <Forward30Icon />,
                rewind: <Backward30Icon />,
                play: <PlayIcon />,
                pause: <PauseIcon />
            }}
        />
    </div>
}

AudioPlayer.prototype = {
    src: PropTypes.string,
    audioRef: PropTypes.object,
    onPlay: PropTypes.func,
    onPause: PropTypes.func,
    onSeeked: PropTypes.func,
    onLoadedData: PropTypes.func,
    onListen: PropTypes.func,
    onError: PropTypes.func,
}
export default AudioPlayer;